import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import * as moment from 'moment';

@Pipe({
    name: 'dateFormat',
    pure: true,
    standalone: false
})
export class DateFormatPipe implements PipeTransform {
  constructor(private translateService: TranslateService) {}

  transform(value: any, ...args: unknown[]): string {
    if (value !== null) {
      return moment(value).format('DD-MM-YYYY');
    } else {
      return this.translateService.instant('admin.module.price_lists.price_lists_grid.not_modified');
    }
  }

}
